module.exports = __webpack_public_path__ + "static/media/4.2ad12f40.svg";